function initNewsletterForm($form) {
  const $inputLabels = $form.querySelectorAll('.farm-newsletter-form_label');
  const $newsletterFormEmail = document.querySelector('.farm-newsletter-form_label-email');
  const $formErrorMessage = $form.querySelector('.error_message');
  const $formSubmitButton = $form.querySelector('button[type="submit"]');
  const $formSubmitButtonText = $form.querySelector('button[type="submit"]').innerText;
  const $feedbackDismissButtons = $form.querySelectorAll('.feedback-dismiss');
  const $bannerClockSubscribe = $form.closest('.banner-clock-subscribe');
  const $source = $form.getAttribute('data-source');

  const invalidEmailErrorMessage = 'Invalid e-mail, try again.';
  const generalErrorMessage =
    'It was not possible to subscribe you. Please, try again later or contact Customer Service.';
  const subscriptionURL = `${ThemeSettings.farmrio_api_base_url}/marketing/subscription/`;

  function clearFormMessages() {
    $form.classList.remove('error');
    $form.classList.remove('success');
    $newsletterFormEmail.classList.remove('hidden');

    $inputLabels.forEach(($label) => {
      const $emailInput = $label.querySelector('.farm-newsletter-form_input-email');
      $emailInput.value = '';
      $label.classList.remove('focus');
    });
  }

  function setErrorState(message) {
    $form.classList.add('error');
    $formErrorMessage.innerText = message;
  }

  if ($feedbackDismissButtons) {
    $feedbackDismissButtons.forEach(($button) => {
      $button.addEventListener('click', clearFormMessages);
    });
  }

  $form.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    $formSubmitButton.disabled = true;
    $formSubmitButton.innerText = 'Subscribing...';

    const formData = new FormData(e.target);
    const formEntries = Object.fromEntries(formData);

    const body = {
      email: formEntries.email,
      klaviyo: {
        listId: formEntries.klaviyo_list_id,
      },
      source: $source,
    };

    fetch(subscriptionURL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    })
      .then(async (res) => {
        $formSubmitButton.disabled = false;
        $formSubmitButton.innerText = $formSubmitButtonText;

        const data = await res.json();

        if (res.status === 200) {
          if (data.shopify.subscribed && data.klaviyo.subscribed) {
            $newsletterFormEmail.classList.add('hidden');
            $form.classList.add('success');
            const eventName = window.FarmRio.events.farmNewsletterFormSubscribed;
            const event = new CustomEvent(eventName, { detail: $source });
            document.dispatchEvent(event);
            return;
          }
        }

        const errorMessage = res.status === 400 ? invalidEmailErrorMessage : generalErrorMessage;
        setErrorState(errorMessage);
      })
      .catch(() => {
        setErrorState(generalErrorMessage);
      });
  });

  $inputLabels.forEach(($label) => {
    const $input = $label.querySelector('.farm-newsletter-form_input');
    const $inputCleaner = $label.querySelector('.newsletter-input-clean');

    if ($input) {
      $input.addEventListener('focus', () => {
        $label.classList.add('focus');
        if (!$bannerClockSubscribe) {
          return;
        }
        $bannerClockSubscribe.classList.add('is-visible');
      });
      $input.addEventListener('focusout', () => {
        if (!$bannerClockSubscribe) {
          return;
        }
        $bannerClockSubscribe.classList.remove('is-visible');
      });
      $input.addEventListener('blur', () => {
        if (!$input.value) {
          $label.classList.remove('focus');
        }
      });
    }

    if ($inputCleaner && $input) {
      $inputCleaner.addEventListener('click', () => {
        $input.value = '';
        $input.focus();
      });
    }
  });
}

document.querySelectorAll('.farm-newsletter-form').forEach(initNewsletterForm);
